<!--Using a Emodal Header Template-->

<emodal-header [headerConfigs]="emodalHeaderConfigs" (OnLogOut)="OnLogOut()"
  (OnInit)="OnInit()" (OnLanguageChanged)="OnLanguageChanged($event)" ></emodal-header>
